<script>
import Vue from 'vue';
import {mapState} from 'vuex';
import moment from 'moment';

export default Vue.extend({
    computed: {
        ...mapState({
            user: state => state.auth.user,
            tricks: state => state.dashboard.dashboardPage.tricks
        }),
        date: {
            get() {
                moment.locale(this.$locale.current());
                return moment().format('dddd Do MMMM YYYY');
            }
        },
        trick: {
            get() {
                return this.tricks[Math.floor(Math.random() * 2)]
            }
        }
    },
});
</script>
<template>
    <div class="dashboard-welcome">
        <div class="dashboard-welcome__left">
            <div class="dashboard-welcome__trick">
                <span>{{ $t('dashboard.tricks.welcome') }} {{ user.firstName }} {{ user.lastName }}.</span>
                <span>{{ $t('dashboard.tricks.' + trick + '.message') }}</span>
                <span>
                    <router-link :to="$t('dashboard.tricks.' + trick + '.link')">
                        <span class="navigation-menu__link-text">{{ $t('dashboard.tricks.click') }}</span>
                    </router-link>
                </span>
            </div>
        </div>
        <div class="dashboard-welcome__right">
            <div class="dashboard-welcome__time">
                {{ date }}
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/DashboardWelcome/DashboardWelcome.vue